import {
  Equipments,
  Inventory,
  Trenazhor,
  Barbells,
  Dumbbells,
} from "../components";

const pageComponents = (
  handleSetActivePage: (page: number) => void,
  equipments: any[]
) => [
    <div key="equipments-0" className="equipments-page-content">
      <h2 className="main-title">Какое оборудование есть у вас?</h2>
      <Equipments
        handleSetActivePage={handleSetActivePage}
        equipments={equipments}
      />
    </div>,
    <div key="equipments-1" className="equipments-page-content">
      <h2 className="main-title">Какое оборудование есть у вас?</h2>
      <Inventory />
    </div>,
    <div key="equipments-2" className="equipments-page-main">
      <h2 className="main-title">Какие тренажеры есть у вас?</h2>
      <Trenazhor />
    </div>,
    <div key="equipments-3" className="equipments-page-main">
      <Barbells />
    </div>,
    <div key="equipments-4" className="equipments-page-main">
      <Dumbbells />
    </div>,
  ];

export default pageComponents;

export * from "./dummyData";

// telegram и links экспортируются напрямую, не через barrel, чтобы избежать циклических импортов
export * from "./links";
